import { useEffect, useSyncExternalStore } from "react";
import {
  selectTenantLogoUrl,
  usePublicTenantSettings,
} from "modules/settings/api";
import {
  getTenantLogo,
  setTenantLogo,
  subscribeTenantLogo,
} from "utils/tenant-logo";

/**
 * The tenant logo URL for the ERP's own chrome (sidebar, login screen), or
 * `null` when the tenant has none — the caller then renders the Amer logo.
 *
 * Paints from the cache in utils/tenant-logo.js first, then refreshes it from
 * the public `corporate/settings`. Only an answer that carries
 * `company_info` overwrites the cache, so a failed read keeps the last known
 * logo. `isFetching` is checked so a remount does not replay a stale cached
 * answer over a logo the Settings screen has just saved.
 */
export default function useTenantLogo() {
  const { data, isFetching } = usePublicTenantSettings();

  useEffect(() => {
    if (isFetching) return;
    const url = selectTenantLogoUrl(data);
    if (url !== undefined) setTenantLogo(url);
  }, [data, isFetching]);

  return useSyncExternalStore(subscribeTenantLogo, getTenantLogo);
}
